//
//
//
//
//
//

import OfficialInfoPage from '@/components/page/OfficialInfoPage.vue'
export default {
  name: 'OfficialInfo',
  layout: 'privacy',
  components: { OfficialInfoPage },
  data() {
    return {
      pageHash: 'general_info',
    }
  },
  created() {
    this.$nuxt.$on('change-page', (url) => {
      this.pageHash = url
    })
  },
  mounted() {
    this.pageHash = this.$route.hash.length
      ? this.$route.hash.substring(1)
      : 'general_info'
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      title: this.$getTextSetting('title'),
      htmlAttrs: {
        ...i18nHead.htmlAttrs,
        dir: this.$direction(),
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$getTextSetting('description'),
        },
        {
          name: 'robots',
          content: 'nofollow',
        },
      ],
    }
  },
}
